import { useEffect } from "react";
import CreateRoutes from "./routes";
import { useTranslation } from "react-i18next";
import { NetworkStatusProvider } from "./Context/NetworkStatusContext";
import moment from "moment-timezone";
import { SyncDataModalProvider } from "./Context/SyncDataModalContext";
import { PositionManageProvider } from "./Context/PositionManageContext";
import { SettingsProvider } from "./Context/SettingsContext";
import MaintenancePage from "./pages/MaintenancePage";
import { SsoLoginProvider } from "./Context/SsoLoginContext";
import { ExecutiveProvider } from "./Context/ExecutiveContext";
import { SnPlanProvider } from "./Context/SuccessionPlanStepContext";

moment.tz.setDefault("America/Denver");

function App() {
  const { i18n } = useTranslation();
  const isMaintenance = false; // If set to true, the site will enter maintenance mode.
  useEffect(() => {
    const storedLanguage = sessionStorage.getItem("sessionLang");
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, [i18n]);

  if (isMaintenance) {
    return <MaintenancePage />;
  }

  return (
    <>
      <NetworkStatusProvider>
        <SettingsProvider>
          <SyncDataModalProvider>
            <SsoLoginProvider>
              <PositionManageProvider>
                <ExecutiveProvider>
                  <SnPlanProvider>
                    <CreateRoutes />
                  </SnPlanProvider>
                </ExecutiveProvider>                
              </PositionManageProvider>
            </SsoLoginProvider>
          </SyncDataModalProvider>
        </SettingsProvider>
      </NetworkStatusProvider>
    </>
  );
}

export default App;
